<span class="tags">
    <span *ngFor="let tag of tagMapList">
        <span class="btn btn-{{tag.colorClassName}} m-1 text-nowrap" data-bs-toggle="tooltip" data-bs-placement="top" title="{{tag.tagNote}}"
              (mouseenter)="tagMouseOverID=tag.tagMapID" (mouseleave)="tagMouseOverID=0">
            <span style="position:absolute;top:-5px" class="btn btn-dark"
                  *ngIf="tag.tagNote!=null&&tag.tagNote!=''&&tagMouseOverID==tag.tagMapID">
                {{tag.tagNote}}
            </span>
            <i class="fas fa-tag"></i>
            {{isPrefix && tag.tagTypePrefix != null && tag.tagTypePrefix != '' ? tag.tagTypePrefix + ' | ' : ''}}
            {{tag.tagTypeName}}
        </span>
        <span *ngIf="false">
            <span class="tag-prefix btn-dark">{{tag.tagTypePrefix}}</span>
            <span class="tag btn-{{tag.colorClassName}}">{{tag.tagTypeName}}</span>
            <span class="tag-suffix border-{{tag.colorClassName}}"></span>
        </span>
    </span>
</span>
